
import React from 'react';
import { Helmet } from "react-helmet";
import { Link } from 'react-router-dom';

import HomepageAnimatedBanner from '../Components/CustomComponents/HomepageAnimatedBanner';
import SocialIconsComponent from '../Components/CustomComponents/SocialIconsComponent';

function TermsAndConditions() {
    return (

        <div className="home-wrapper">

            <Helmet>
                <meta
                    name="description"
                    content="VCASSO LLC Terms and Conditions Page." />
                <link rel="canonical" href={window.location.href} />
                <title>VCASSO LLC | Terms and Conditions</title>
            </Helmet>

            <HomepageAnimatedBanner />

            <div className="container">

                <div className="privacy-policy">

                    <h1>Terms and Conditions</h1>

                    <p><strong>Effective Date:</strong> May 16, 2026</p>

                    <p>
                        These Terms and Conditions govern the use of the wildfire weather
                        alert notification services provided by VCASSO LLC.
                    </p>

                    <h2>Service Description</h2>

                    <p>
                        VCASSO LLC provides automated SMS notifications regarding wildfire
                        weather conditions, including Red Flag Warnings, warning updates,
                        and warning cancellations intended for authorized operational
                        personnel and related safety communications.
                    </p>

                    <h2>SMS Messaging Consent</h2>

                    <p>
                        By voluntarily providing a mobile phone number, users consent to
                        receive automated SMS notifications related to wildfire weather
                        alerts and operational safety communications.
                    </p>

                    <p>
                        Message frequency may vary depending on weather activity and
                        operational conditions.
                    </p>

                    <p>
                        Users may reply STOP at any time to unsubscribe from SMS messages
                        or HELP for assistance.
                    </p>

                    <p>
                        Standard message and data rates may apply depending on the user's
                        mobile carrier plan.
                    </p>

                    <h2>Acceptable Use</h2>

                    <p>
                        Users agree to use this service only for lawful operational and
                        safety-related purposes. Unauthorized use or misuse of the service
                        is prohibited.
                    </p>

                    <h2>Service Availability</h2>

                    <p>
                        VCASSO LLC does not guarantee uninterrupted or error-free delivery
                        of SMS notifications. Delivery may be affected by weather conditions,
                        carrier availability, technical limitations, or third-party service
                        interruptions.
                    </p>

                    <h2>Limitation of Liability</h2>

                    <p>
                        VCASSO LLC shall not be held liable for delays, failures, or
                        inaccuracies in SMS alert delivery or for actions taken based on
                        received notifications.
                    </p>

                    <h2>Privacy</h2>

                    <p>
                        Information related to SMS communications is handled in accordance
                        with our Privacy Policy.
                    </p>

                    <h2>Third-Party Providers</h2>

                    <p>
                        SMS notifications may be delivered through third-party communication
                        providers including
                        <a href="https://www.twilio.com"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Twilio
                        </a>.
                    </p>

                    <h2>Changes to These Terms</h2>

                    <p>
                        VCASSO LLC reserves the right to modify these Terms and Conditions
                        at any time. Updated versions will be posted on this page with a
                        revised effective date.
                    </p>

                    <h2>Contact Information</h2>

                    <p>
                        For questions regarding these Terms and Conditions, contact:
                    </p>

                    <p>
                        VCASSO LLC
                        <br />
                        <a
                            title="Email VCASSO LLC"
                            href="mailto:vanja@vcasso.com?subject=Terms and Conditions Inquiry"
                        >
                            vanja@vcasso.com
                        </a>
                    </p>

                </div>

                <SocialIconsComponent />

            </div>

        </div>

    );
}

export default TermsAndConditions;